<!-- Regular pretrip content -->
<!-- <div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div [innerHTML]='"copy.html.PretripTravel.PretripTravelCopy"|copy|async'></div>
    </div>
</div> -->

<!-- FIB content -->
<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div [innerHTML]='"copy.html.FIBTravel.FIBTravelCopy"|copy|async'></div>
    </div>
</div>